/**
 * 앱(안드로이드)에서 로그인한 단골이면 푸시를 켭니다(DEV-12 3 · lib/push.js).
 * 권한이 이미 있으면 기기 등록 · 토큰 서버에 두기, 알림을 누르면 그 화면으로. 웹에서는 아무것도 하지 않습니다
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isNativeApp, startNativePush } from '../lib/push.js';
import { useSession } from '../stores/session.js';

export function useNativePush() {
    const navigate = useNavigate();
    const member = useSession((state) => state.status === 'member');
    useEffect(() => {
        if (!member || !isNativeApp()) {
            return;
        }
        startNativePush((path) => navigate(path)).catch((error) => {
            console.error('[push] 시작하지 못함', error?.name);
        });
    }, [member, navigate]);
}
